import gql from 'graphql-tag';
import { scheduledSessionParticipantEntryFieldsFragment } from '../fragments';

export const manuallyAssignEvaluationToParticipantMutation = gql`
  mutation ManuallyAssignEvaluationToParticipant(
    $scheduledSessionId: ID!
    $participantId: ID!
    $evaluation: ID!
  ) {
    manuallyAssignEvaluationToParticipant(
      scheduledSessionId: $scheduledSessionId
      participantId: $participantId
      evaluation: $evaluation
    ) {
      ...AdminScheduledSessionParticipantEntryFields
    }
  }

  ${scheduledSessionParticipantEntryFieldsFragment}
`;
